import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#1155aa", // Logo Blue
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f5f5f5",
    },
    background: {
      default: "#121212", // Deep Anthracite
      paper: "#1e1e1e", // Slightly lighter for cards
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0b0b0",
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: {
      fontWeight: 600,
      textTransform: "none", // Modern button style
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "10px 24px",
        },
        containedPrimary: {
          "&:hover": {
            backgroundColor: "#cc5200", // Darker orange on hover
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: "none", // Remove default elevation overlay in dark mode
          border: "1px solid #333333",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "rgba(18, 18, 18, 0.9)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid #333333",
        },
      },
    },
  },
});
